<template>
  <!-- 添加教练 -->
  <div class="container">
    <div class="vue">
      <div class="header">
        <div class="text">添加教练</div>
      </div>
      <div class="content flex">
        <div class="left"></div>
        <div class="right FZ0875">
          <div class="form flex">
            <span class="text">教练姓名</span>
            <el-input
              v-model="formCoach.name"
              size="small"
              placeholder=""
            ></el-input>
          </div>
          <div class="form flex">
            <span class="text">私教课价格</span>
            <el-input
              v-model="formCoach.price"
              size="small"
              placeholder=""
            ></el-input>
          </div>
          <div class="form flex">
            <span class="text">教练图片</span>
            <div class="image">
              <el-upload
                action="#"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :file-list="fileList"
                :on-remove="handleRemove"
                :limit="1"
                :http-request="uploadSectionFile"
                :on-exceed="handleExceed"
              >
                <!-- <i class="el-icon-plus"></i> -->
                <div class="addimage flex">
                  <el-image
                    :src="require('@/assets/ProductManage/tjtp.png')"
                  ></el-image>
                  <span class="text">添加图片</span>
                </div>
              </el-upload>
              <!-- <div class="imagelist"></div> -->
            </div>
          </div>
          <div class="form flex">
            <span class="text">所受课程</span>
            <el-input
              class="new-input"
              v-model="formCoach.courses1"
              size="small"
              placeholder=""
            ></el-input>
            <el-input
              class="new-input"
              v-model="formCoach.courses2"
              size="small"
              placeholder=""
            ></el-input>
            <el-input
              class="new-input"
              v-model="formCoach.courses3"
              size="small"
              placeholder=""
            ></el-input>
          </div>
          <div class="form flex">
            <span class="text">教练擅长</span>
            <el-input
              class="textarea"
              type="textarea"
              :rows="2"
              placeholder=""
              v-model="formCoach.goodAt"
            >
            </el-input>
          </div>
          <div class="form flex">
            <span class="text">教练资质</span>
            <el-input
              class="textarea"
              type="textarea"
              :rows="2"
              placeholder=""
              v-model="formCoach.introduction"
            >
            </el-input>
          </div>
          <div class="form flex">
            <span class="text">约课规则</span>
            <el-input
              class="textarea"
              type="textarea"
              :rows="2"
              placeholder=""
              v-model="formCoach.appointmentRules"
            >
            </el-input>
          </div>
          <div class="form flex">
            <span class="text"></span>
            <el-button
              class="sure"
              size="small"
              type="primary"
              @click="confirmBut"
              >确认</el-button
            >
            <el-button class="sure" size="small" plain @click="cancelBut"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUploadByBase64 } from '@/api/uploading'
import { apiAddFitnessCoach } from '@/api/fitness'
let _self
export default {
  name: '',
  props: [''],

  data() {
    return {
      uploadActionUrl: '',
      formCoach: {
        name: '',
        courses1: '',
        courses2: '',
        courses3: '',
        price: '',
        goodAt: '',
        introduction: '',
        appointmentRules: ''
      },
      formCoachList: [
        '姓名不能为空！',
        '私教课价格不能为空！',
        '所受课程不能为空！',
        '所受课程不能为空！',
        '所受课程不能为空！',
        '教练擅长不能为空！',
        '教练资质不能为空！',
        '约课规则不能为空！'
      ],
      fileList: [],
      imageUrl: '',
      dialogVisible: false,
      imageUpload: '' // 教练照片
    }
  },
  computed: {},

  beforeMount() {},

  mounted() {
    _self = this
    //   uploadActionUrl
  },

  methods: {
    addimageBut() {},
    /**
     * 文件上传-自定义上传行为
     * */
    uploadSectionFile(params, file1) {
      if (_self.fileList.length > 0) {
        this.$message.error('最高可上传一个图片')
        return
      }
      console.log(params)
      console.log(file1)
      const file = params.file
      const fileType = file.type
      const isImage = fileType.indexOf('image') !== -1
      console.log(file)
      const isLt2M = file.size / 1024 / 1024 < 2
      // 这里常规检验，看项目需求而定
      if (!isImage) {
        this.$message.error('只能上传图片格式png、jpg、gif!')
        return
      }
      if (!isLt2M) {
        this.$message.error('只能上传图片大小小于2M')
        return
      }
      // 将图片转成base64
      const reader = new FileReader()
      reader.readAsDataURL(file) // 开始转
      reader.onload = function(e) {
        // const _self = this
        // this.result // 这个就是base64编码了
        this.imageUrl = this.result.split('base64,')[1]
        apiUploadByBase64({
          base64: this.imageUrl,
          path: 'BackstageShop'
        }).then(res => {
          if (res.status === 0) {
            _self.$message({
              message: '图片上传成功',
              type: 'success'
            })
            _self.imageUpload = res.data
            _self.fileList[0] = res.data
          }
        })
        console.log(_self.imageUpload)
        console.log(_self.fileList)
      }
    },
    // 删除文件之前的钩子
    handleRemove(file, fileList) {
      _self.fileList = []
    },
    // 文件超出个数限制时的钩
    handleExceed(file, fileList) {
      console.log(fileList)
      console.log(this.fileList)
      this.$message.error('最高可上传一个图片')
    },

    // 取消按钮
    cancelBut() {
      // 返回上一页
      this.$router.go(-1)
    },
    // 按钮
    // 确定上传按钮
    confirmBut() {
      if (this.objNaN(this.formCoach, this.formCoachList)) {
      } else {
        const courses = `${this.formCoach.courses1 + ','}${this.formCoach
          .courses2 + ','}${this.formCoach.courses3}`
        console.log(courses)

        apiAddFitnessCoach({
          name: this.formCoach.name,
          introduction: this.formCoach.introduction,
          goodAt: this.formCoach.goodAt,
          price: this.formCoach.price,
          coursesTaught: courses,
          img: this.imageUpload,
          appointmentRules: this.formCoach.appointmentRules
        }).then(res => {
          if (res.status === 0) {
            this.$message({
              type: 'success',
              msg: res.msg
            })
          }
        })
      }
    },
    w() {
      apiUploadByBase64({
        base64: this.imageUrl,
        path: 'BackstageShop'
      }).then(res => {
        if (res.status === 0) {
          this.$message.success('文件上传成功')
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .left {
      width: 30%;
    }
    .right {
      width: 70%;
      .form {
        width: 100%;
        line-height: 3;
        // align-items: center;
        justify-content: flex-start;
        padding-bottom: 10px;
        text-align: right;
        .text {
          width: 13%;
          padding-right: 10px;
        }
        .sure {
          padding: 8px 28px;
        }
        .image {
          .addimage {
            height: 100%;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .el-image {
              width: 30px;
              height: 30px;
            }
            .text {
              padding: 0;
              padding-top: 10px;
              width: 100%;
              line-height: normal;
            }
          }
          //   .left_name {
          //     width: 80px;
          //     height: 80px;
          //     border: 1px solid #e3e3e3;
          //     padding: 6px;
          //     flex-direction: column;
          //     align-items: center;
          //     justify-content: center;
          //     color: #858585;
          //   }
        }
        .el-input,
        .editor,
        .textarea {
          width: 87%;
        }
        .new-input {
          width: 28%;
          padding-right: 10px;
        }
      }
    }
  }
}
</style>
